module.exports = __webpack_public_path__ + "static/img/zcbt2.6b189411.png";